import { Space, Tag, Tooltip } from "antd"
import { Button } from "src/components/actions/button"
import { PencilSvg } from "src/components/Svg"
import styled from "styled-components"
import { EyeOutlined, GlobalOutlined, TableOutlined } from "@ant-design/icons";

export function getColumns(onEdit, onEditTable, isReadOnly = false, onEditFeeds = null) {
  return [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      defaultSortOrder: "ascend",
    },
    {
      title: "Название",
      dataIndex: "nameRu",
      key: "nameRu",
      sorter: (a, b) => a.nameRu - b.nameRu,
    },
    {
      title: "Сокращенное название",
      dataIndex: "shortNameRu",
      key: "shortNameRu",
      sorter: (a, b) => a.shortNameRu - b.shortNameRu,
    },
    {
      title: "Самовывоз",
      dataIndex: "isPickup",
      key: "isPickup",
      sorter: (a, b) => a.isPickup - b.isPickup,
      render: (text) => (
        <StyledTag color={text ? "rgb(56, 142, 60)" : "rgb(211, 47, 47)"}>
          {text ? "ДА" : "НЕТ"}
        </StyledTag>
      ),
    },
    {
      title: "Доставка",
      dataIndex: "isDelivery",
      key: "isDelivery",
      sorter: (a, b) => a.isDelivery - b.isDelivery,
      render: (text) => (
        <StyledTag color={text ? "rgb(56, 142, 60)" : "rgb(211, 47, 47)"}>
          {text ? "ДА" : "НЕТ"}
        </StyledTag>
      ),
    },
    {
      title: "Включен",
      dataIndex: "isActive",
      key: "isActive",
      sorter: (a, b) => a.isActive - b.isActive,
      render: (text) => (
        <StyledTag color={text ? "rgb(56, 142, 60)" : "rgb(211, 47, 47)"}>
          {text ? "ДА" : "НЕТ"}
        </StyledTag>
      ),
    },
    {
      title: "Видимость",
      dataIndex: "isShow",
      key: "isShow",
      sorter: (a, b) => a.isShow - b.isShow,
      render: (text) => (
        <StyledTag color={text ? "rgb(56, 142, 60)" : "rgb(211, 47, 47)"}>
          {text ? "Виден" : "Не виден"}
        </StyledTag>
      ),
    },

    ...(onEdit || onEditTable || onEditFeeds ? [{
      title: "Действие",
      key: "action",
      width: 100,
      render: (_, record) => (
        <Space size="small">
          <StyledFlex>
            {onEdit && (
              <Tooltip placement="top" title={isReadOnly ? "Просмотр" : "Редактировать"} mouseLeaveDelay={0}>
                <Button size="small" type="link" onClick={() => onEdit(record.id)}>
                  {isReadOnly ? <EyeOutlined /> : <PencilSvg />}
                </Button>
              </Tooltip>
            )}
            {onEditTable && (
              <Tooltip placement="top" title="Редактировать столики" mouseLeaveDelay={0}>
                <Button size="small" type="link" onClick={() => onEditTable(record.id)}>
                  <TableOutlined style={{ width: "16px" }} />
                </Button>
              </Tooltip>
            )}
            {onEditFeeds && (
              <Tooltip placement="top" title="Фиды: признаки и ссылки" mouseLeaveDelay={0}>
                <Button size="small" type="link" onClick={() => onEditFeeds(record.id)}>
                  <GlobalOutlined style={{ width: "16px" }} />
                </Button>
              </Tooltip>
            )}
          </StyledFlex>

        </Space>
      ),
    }] : []),
  ]
}

const StyledTag = styled(Tag)`
  font-weight: 600;
  text-transform: uppercase;
`

const StyledFlex = styled.div`
  min-width: 120px;
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 10px;
`

